import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// TanStack Router types caught route errors as `unknown`; normalize before use.
export function toError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}
